import axios from "axios";
import {ResponseItem, ResponseRemove} from "../../models/clientModels/interfaces/Response";
import * as Params from "../../models/clientModels/interfaces/apiParams";
import {KPFolder} from "../../models/serverModels/archive/KPFolder";

const rootApi = process.env.REACT_APP_API_KEY;

const archiveFolder = axios.create({
  baseURL: rootApi,
});

export const getItem = async (params: Params.GetItem): Promise<ResponseItem<KPFolder>> =>
  archiveFolder({
    url: `/Folder/${params.id}`,
    method: "get",
    params,
  }).then((res) => res.data);

export const create = async (params: Params.Create<KPFolder>): Promise<ResponseItem<KPFolder>> =>
  archiveFolder({
    url: `/Folder/`,
    method: "post",
    data: params,
  }).then((res) => res.data);

export const remove = async (params: Params.Remove): Promise<ResponseRemove> =>
  archiveFolder({
    url: `/Folder/${params.id}`,
    method: "delete",
    data: params,
  }).then((res) => res.data);

export const update = async (params: Params.Update<KPFolder>): Promise<ResponseItem<KPFolder>> =>
  archiveFolder({
    url: `/Folder/${params.id}`,
    method: "put",
    data: params,
  }).then((res) => res.data);
